import { gql } from '@apollo/client';

export const getChargerGroupsForChargerPrice = gql`
  query getChargerGroupsForChargerPrice($input: GetTariffInput!) {
    getTariff(input: $input) {
      chargerGroups {
        altId
        chargerGroupName
      }
    }
  }
`;
